export default __webpack_public_path__ + "4162114c6dffc96d5b1e6a1326568028.png";